import { NavLink } from 'react-router-dom';

/**
 * Tab navigation across the founder tools. Mirrors ModerationNav (same
 * `.modnav` styling + NavLink active state) so the founder section reads as
 * clean top tabs instead of a paragraph of arrow links.
 */
export function FounderNav() {
  return (
    <nav className="modnav">
      <NavLink to="/founder" end>
        Overview
      </NavLink>
      <NavLink to="/founder/moderators">People</NavLink>
      <NavLink to="/founder/audit">Audit feed</NavLink>
      <NavLink to="/founder/institutions">Institutions</NavLink>
      <NavLink to="/founder/flags">Feature flags</NavLink>
      <NavLink to="/founder/diagnostics">Diagnostics</NavLink>
      <NavLink to="/founder/docs">Pilot binder</NavLink>
      <NavLink to="/">← App</NavLink>
    </nav>
  );
}
